import { render, staticRenderFns } from "./OrgDisabled.vue?vue&type=template&id=6ca15c84&"
import script from "./OrgDisabled.vue?vue&type=script&lang=ts&"
export * from "./OrgDisabled.vue?vue&type=script&lang=ts&"
import style0 from "./OrgDisabled.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports